import React, { useContext } from 'react';
import assetAccountContext from '../../context/assetAccountContext';

import styles from './AccountSummary.module.scss';
import BackgroundBar from '../styled/BackgroundBar';
import AssetSummaryTable from '../accountOverview/AssetSummaryTable';
import AssetAllocationChartTable from './AssetAllocationChartTable';
import SeeDefinitions from '../styled/SeeDefinitions';

const AccountSummary: React.FC = () => {
  const { selectedAccount } = useContext(assetAccountContext);

  if (selectedAccount === undefined) {
    return null;
  }

  const { assets } = selectedAccount.dailyReport;

  const { guidelines } = selectedAccount.monthlyReport || { guidelines: null };

  const assetTables = assets.map((asset, index) => (
    <AssetSummaryTable
      className={styles['summary-table']}
      key={asset.assetName}
      assetCategory={asset}
      invGuidelines={guidelines}
    />
  ));

  return (
    <BackgroundBar className={styles['summary-background']}>
      <div className={styles['summary-container']}>
        {assetTables}

        <AssetAllocationChartTable
          className={styles['chart-table']}
          selectedAccount={selectedAccount}
        />
      </div>
      <div className={styles['disclaimer']}>
        <SeeDefinitions additionalText="Figures may not total 100% due to rounding." />
      </div>
    </BackgroundBar>
  );
};

export default AccountSummary;
